import React, { Component } from 'react'
import profileSelector from '../../selectors/profileSelector'
import authSelector from '../../selectors/authSelector'
import { isEmptyObject } from '../../helpers/utility'
import { PulseLoader } from 'halogen'
import { FETCH_USER_PROFILE } from '../../actions/actions'
import { connect } from 'react-redux'

const styles = {
  spinner: {
    display: 'flex',
    height: '80vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
}

class UserAccountContainer extends Component {
  componentWillMount() {
    if (isEmptyObject(this.props.userProfile)) {
      const { dispatch, userId, userType } = this.props
      dispatch({ type: FETCH_USER_PROFILE, userId, userType })
    }
  }

  render() {
    if (this.props.aSyncCall)
      return (
        <div style={styles.spinner}>
          <PulseLoader color={'#00abde'} />
        </div>
      )

    return <div>{this.props.children}</div>
  }
}

function mapStateToProps(state) {
  return {
    ...profileSelector(state),
    ...authSelector(state),
  }
}

export default connect(mapStateToProps)(UserAccountContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/UserAccountContainer.js